import { useNavigate } from "react-router-dom";

export const SidebarItem = ({
  icon: Icon,
  label,
  to,
  active,
  onClick,
  children,
  isOpen: propIsOpen,
  setIsOpen: propSetIsOpen,
  isHovered,
  canOpenChildren = true,
}) => {
  const navigate = useNavigate();
  const hasChildren = !!children;

  const isOpen = propIsOpen ?? false;
  const setIsOpen = propSetIsOpen ?? (() => {});

  const handleClick = () => {
    if (hasChildren) {
      if (canOpenChildren) setIsOpen((prev) => !prev);
    } else {
      if (to) navigate(to);
    }
    if (onClick) onClick();
  };

  return (
    <div className="mb-1">
      <div
        className={`
          relative flex items-center p-3.5 rounded-xl cursor-pointer 
          transition-all duration-300 ease-out group overflow-hidden
          ${active 
            ? "bg-gradient-to-r from-yellow-400 to-yellow-500 text-gray-900 shadow-lg" 
            : "hover:bg-gray-800/50 text-gray-300 hover:text-white"
          }
        `}
        onClick={handleClick}
      >
        {active && (
          <div className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-8 bg-gray-900 rounded-r-full"></div>
        )}
        {!active && (
          <div className="absolute inset-0 bg-gradient-to-r from-yellow-400/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        )}

        {/* Icon */}
        {Icon && (
          <div className="relative z-10 flex items-center justify-center">
            <Icon 
              className={`
                text-xl min-w-[20px] transition-all duration-300
                ${active 
                  ? "text-gray-900" 
                  : "text-gray-400 group-hover:text-yellow-400 group-hover:scale-110"
                }
              `} 
            />
          </div>
        )}
        <span
          className={`
            relative z-10 ml-4 text-sm font-medium whitespace-nowrap 
            transition-all duration-300 ease-out
            ${active ? "text-gray-900" : "text-gray-300 group-hover:text-white"}
            ${isHovered 
              ? "opacity-100 translate-x-0 max-w-xs" 
              : "opacity-0 -translate-x-2 max-w-0 overflow-hidden"
            }
          `}
        >
          {label}
        </span>
        {hasChildren && isHovered && canOpenChildren && (
          <div className={`
            ml-auto transition-transform duration-300
            ${isOpen ? "rotate-180" : "rotate-0"}
          `}>
            <svg 
              className="w-4 h-4" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </div>
        )}
      </div>
      {hasChildren && isHovered && canOpenChildren && (
        <div
          className={`
            transition-all duration-300 ease-in-out overflow-hidden
            ${isOpen ? "max-h-96 opacity-100 mt-1" : "max-h-0 opacity-0"}
          `}
        >
          <div className="ml-8 space-y-1 border-l-2 border-gray-700 pl-4">
            {children}
          </div>
        </div>
      )}
    </div>
  );
};